import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { XIcon } from 'lucide-react';
export function SolutionsFailed() {
  const failures = ['Las dietas de moda son demasiado complejas y agresivas para el sistema digestivo después de los 65 años.', 'Los suplementos de televisión prometen milagros, pero ignoran que la inflamación real se detiene en la cocina, no en una cápsula.', 'Las recetas "saludables" exigen ingredientes caros de tiendas orgánicas que están fuera de tu presupuesto y de tu vecindario.', 'Muchos libros de cocina para personas mayores no consideran que a veces tus manos están demasiado cansadas para pasar 2 horas picando vegetales.'];
  return <div className="bg-white py-24 px-6" data-id="element-144">
      <AnimatedSection className="max-w-4xl mx-auto" data-id="element-145">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-146">
          ¿Por qué lo que has intentado no funcionó?
        </h2>
        <div className="grid gap-6" data-id="element-147">
          {failures.map((text, index) => <div key={index} className="flex items-start gap-4 p-6 rounded-2xl bg-brand-cream/50 border border-brand-gray/10" data-id="element-148">
              <div className="flex-shrink-0 mt-1 bg-red-100 p-2 rounded-full" data-id="element-149">
                <XIcon className="w-6 h-6 text-red-600" data-id="element-150" />
              </div>
              <p className="text-lg" data-id="element-151">{text}</p>
            </div>)}
        </div>
      </AnimatedSection>
    </div>;
}